<template>
  <div class="container">
    <template v-if="showBtn">
      <div class="download-container flex-space-between" v-if="isMobile" @click="downloadApp">
        <div class="flex-left-align">
          <img src="@/assets/icons/ikea_app_logo.png" class="app-icon"/>
          <div style="text-align: left">
            <div style="font-size: 16px;font-weight: bold">立即下载宜家App</div>
            <div style="color: #666666; font-size: 14px; margin-top: 5px">随时随地都能宜家</div>
          </div>
        </div>
        <div class="download-app">下载应用</div>
      </div>
      <img src="@/assets/icons/icon-to-top.svg" class="scroll-to-top" v-else @click="scrollToTop">
    </template>

    <h1 v-if="isLoading" style="text-align: center">精彩即将来袭...</h1>

    <div :class="theme" v-else>
      <div v-for="config in pageConfig.components" v-bind:key="config.id">
        <!-- 第一张为hero的图片 + 下载按钮或者二维码-->
        <div v-if="config.type === 'pub-hero'" class="head">
          <div v-if="isMobile" class="mobile">
            <div class="content">
              <img :src="config.model.image.url" class="header-bg"/>
              <div class="top">
                <div class="privacy-content">
                  应用名称：IKEA 宜家家居<br/>
                  APP版本：iOS/Android {{version}} (更新日期：{{date}}) <br/>
                  开发者信息：宜家电子商务（中国）有限公司 <br/>
                </div>
                <div class="links">
                  <a href="/page/cms/page.html?id=1fa5d180774d11eb95be27aedb5bcc78" class="link">应用涉及权限 </a>
                  <a href="/page/privacy_policy.html" class="link">隐私政策 </a>
                  <a href="/page/terms_and_conditions.html" class="link">使用条款 </a>
                </div>
              </div>
              <div class="logo-content">
                <img src="@/assets/icons/ikea-icon-small.png" class="ikea-icon" />
                <div style="font-size: 14px; margin-top: 5px">IKEA 宜家家居</div>
                <div class="slogan" style="margin-top: 10px">获取最新优惠</div>
                <div class="slogan">享受更多服务</div>
                <div style="font-size: 16px; margin-top: 20px">为大众创造更美好的日常生活。</div>
                <div class="download-btn" @click="downloadApp">立即下载宜家APP</div>
              </div>
            </div>
          </div>
          <div class="pc" v-else>
            <img :src="config.model.image.url.replace('x-oss-process=style/medium','x-oss-process=style/xl')" class="header-bg"/>
            <div class="content">
              <div class="left-content">
                <img src="@/assets/icons/ikea-icon-small.png" class="ikea-icon"/>
                <div style="font-size: 14px; margin-top: 5px">IKEA 宜家家居</div>
                <div class="slogan" style="margin-top: 25px">获取最新优惠</div>
                <div class="slogan">享受更多服务</div>
                <div style="font-size: 18px; margin-top: 20px">为大众创造更美好的日常生活。</div>
                <qrcode :value="link" class="qr-code-logo" style="margin-top: 50px"></qrcode>
                <div style="font-weight: bold;margin-top: 5px">立即扫码下载</div>

                <div class="privacy-content" style="margin-top: 40px; border: none; color: #666666">
                  应用名称：IKEA 宜家家居<br/>
                  APP版本： ios/android {{version}} (更新日期：{{date}}) <br/>
                  开发者信息：宜家电子商务（中国）有限公司 <br/>
                  <a href="/page/cms/page.html?id=1fa5d180774d11eb95be27aedb5bcc78" class="link">应用涉及权限 </a>
                  <a href="/page/privacy_policy.html" class="link">隐私政策 </a>
                  <a href="/page/terms_and_conditions.html" class="link">使用条款 </a> <br/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <image-with-loading
          :src="config.model.image.url.replace('x-oss-process=style/medium','x-oss-process=style/xl')"
          :width="config.model.image.width"
          :height="config.model.image.height"
          v-else-if="config.type === 'pub-image'"
        />
        <div class="text" v-html="config.model.text" v-else-if="config.type === 'pub-text'"></div>
        <video-component :config="{ 
                                    url: config.model.url, 
                                    label: config.model.label, 
                                    products: config.model.products ? config.model.products.productIds : [] 
                                  }" v-else-if="config.type === `pub-video`" />
      </div>

      <div class="bottom" :class="{'bottom-mobile' : isMobile}">
        <img src="@/assets/icons/ikea-icon-small.png" class="ikea-icon"/>
        <div style="margin-top: 5px">宜家家居</div>
        <div style="margin-top:18px; color: #999999;">© Inter IKEA System B.V 2020-2023</div>
        <!--        <div class="download center" style="margin-top:30px;" @click="downloadApp" v-if="!isMobile">-->
        <!--          <div>立即下载 App</div>-->
        <!--        </div>-->
      </div>
    </div>

    <wechat-overlay v-if="showWechatOverlay" />
  </div>
</template>

<script>
  const system = require("@/libs/system");
  const appstore = require("@/libs/appstore");
  import mbff from "@/libs/mbff"
  const config = require("@/config/promotion.json");
  import WechatOverlay from "@/components/WechatOverlay";
  import Qrcode from "@xkeshi/vue-qrcode";
  import ComponentWrapper from "@/pages/cms/pageComponents/ComponentWrapper";
  import ImageWithLoading from "@/components/ImageWithLoading";
  import VideoComponent from "@/pages/cms/pageComponents/VideoComponent";

  const defaultLink =
    "https://res.app.ikea.cn/page/app_download.html?utm_source=unknown";

  export default {
    components: {
      WechatOverlay,
      Qrcode,
      ComponentWrapper,
      ImageWithLoading,
      VideoComponent
    },
    data() {
      return {
        version: "",
        date: "",
        system: system.currentSystem(),
        platform: system.currentPlatform(),
        isMobile: false,
        showWechatOverlay: false,
        link: defaultLink,
        isLoading: true,
        pageConfig: [],
        showBtn: false,
        theme: {}
      };
    },
    mounted() {
      if (window.injectProperty && window.injectProperty.prerender) {
        return;
      }
      this.system = system.currentSystem();
      this.platform = system.currentPlatform();
      if (
        this.system === "iOS" ||
        this.system === "Android" ||
        this.system === "Wechat" ||
        this.system === "miniprogram"
      ) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
      const self = this;
      // handle store activity
      // const retargetingStoreId = this.$route.query.retargeting_store_id;
      // if (retargetingStoreId) {
      //   const activityId = `store_${retargetingStoreId}`;
      //   mbff.get(`/couponEvents/${activityId}`).then(function(response) {
      //     const activity = response.data;
      //     if (activity.available) {
      //       self.$router.push({
      //         name: "activity",
      //         query: { id: activityId }
      //       });
      //     }
      //   });
      // }
      // handel utm source
      var source = this.$route.query.utm_source;
      if (source && !this.isMobile) {
        if (config[source]) {
          this.link = config[source];
        } else {
          mbff.get(`/content/tracking-link?utm_source=${source}`).then(res => {
            self.link = res.data.url
            console.log(self.link);
          }).catch(error => {
            self.link = defaultLink;
          })
        }
      } else {
        this.link = defaultLink;
      }

      mbff
        .get(
          `/cms-service/client-api/pages/page?env=production&key=${
            this.isMobile
              ? "cn--zh--f7f1f71046a511eb82cf5def96d20a8e"
              : "cn--zh--2e93688446a611eb82cf5def96d20a8e"
          }`
        )
        .then(response => {
          self.pageConfig = response.data;
          const description = response.data.metadata.find(x => x.type === "description");
          if (description && description.value) {
            try {
              const data = JSON.parse(description.value);
              if (data.version) {
                self.version = data.version;
              }
              if (data.date) {
                self.date = data.date;
              }
              if (data.theme) {
                self.theme = data.theme;
              }
            } catch(e) {
            }
          }
          if (self.version === "") {
            self.version = appstore.appVersion().version;
          }
          if (self.date === "") {
            self.date = appstore.appVersion().date;
          }
          self.isLoading = false;
        }).catch(error => {
          self.$toast.show(error);
          self.downloadApp()
      })

      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll(e) {
        if (window.scrollY > window.document.body.clientHeight && !this.showBtn) {
          this.showBtn = true
        }
        if (window.scrollY < window.document.body.clientHeight && this.showBtn) {
          this.showBtn = false
        }
      },
      scrollToTop() {
        window.scrollTo(0, 0)
      },
      downloadApp() {
        if (this.$route.query.url) {
          console.log(this.$route.query.url)
          const code = btoa(
            JSON.stringify({
              channel: "ikea",
              url: this.$route.query.url
            })
          );
          console.log(code)
          this.$copyText(code);
        }

        // in wechat, go to YingYongBao for ios, open in browser for Android
        if (this.system === "Wechat") {
          // yingyongbao is not stable, so in wechat always open browser
          this.showWechatOverlay = true;
          return;
          // if (this.platform == "iOS") {
          //   location.href =
          //     "https://a.app.qq.com/o/simple.jsp?pkgname=com.ingka.ikea.app.cn.prod";
          //   return;
          // } else {
          //   this.showWechatOverlay = true;
          //   return;
          // }
        }
        appstore.open(this.version);
      }
    }
  };
</script>

<style scoped>
  .container {
    font-family: "Noto IKEA", Verdana, Helvetica, Arial, sans-serif, "PingFang SC";
    max-width: 1440px;
    margin: 0 auto;
  }
  .head {
    position: relative;
  }
  .row {
    display: flex;
    flex-direction: row;
  }
  .privacy-content {
    text-align: left;
    font-size: 10px;
    line-height: 15px;
    color: #877300;
    border-bottom: 1px solid #E4C71E;
  }
  .ikea-icon {
    width: 60px;
    height: 24px;
  }
  .link {
    text-decoration: underline;
    margin-right: 5px;
    color: #877300;
  }
  .pc .link {
    color: #666666;
  }
  .pc {
    width: 100%;
  }
  .pc .content {
    width: 50%;
  }
  .pc .left-content {
    width: 50%;
    margin: auto;
    padding: 60px 0;
  }
  .mobile .top {
    display: flex;
    flex-direction: row;
    padding: 15px;
    border-bottom: 1px solid #E4C71E;
  }
  .mobile .privacy-content {
    flex: 1;
    border-bottom: none;
    padding: 0px;
  }
  .mobile .links {
    display: flex;
    flex-direction: column;
    font-size: 10px;
    line-height: 15px;
    flex: none;
    align-items: end;
  }
  .mobile .content {
    position: relative;
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .mobile .logo-content {
    padding: 40px 0;
  }
  .header-bg {
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .download-container {
    position: fixed;
    bottom: 0;
    text-align: center;
    width: 100%;
    z-index: 100;
    padding: 15px 24px 25px 24px;
    background-color: white;
    border-top: 1px solid #e5e5e5;
    box-shadow: 0px -1px 0px rgba(0, 0, 0, 0.1);
  }
  .download {
    background-color: #fee100;
    margin: 0 auto;
    width: 274px;
    height: 56px;
    border-radius: 56px;
    font-weight: bold;
    font-size: 20px;
    box-shadow: 0 0 3px 3px #6666661a;
  }
  .download-btn {
    background-color: #111111;
    color: white;
    margin: 40px 50px 0 50px;
    border-radius: 60px;
    height: 50px;
    line-height: 50px;
    font-weight: bold;
    font-size: 15px;
  }
  .center {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .bottom {
    text-align: center;
    padding: 40px 0;
    background-color: #F5F5F5;
    font-size: 14px;
  }
  .bottom-mobile {
    padding-bottom: 120px;
  }
  .qr-code-logo {
    width: 150px;
    height: 150px;
    padding: 10px;
    background-color: white;
    border: 2px solid #E3E3E3;
    border-radius: 4px;
  }
  .light .content {
    color: white;
  }
  .light .privacy-content {
    color: white;
  }
  .light .mobile .link {
    color: white;
  }
  .light .mobile .download-btn {
    background-color: white;
    color: #111111;
  }
  .light .mobile .top {
    opacity: 0.7;
    border-bottom: 1px solid #FFFFFF2E;
  }
  @media (min-width: 0px) {
    .slogan {
      font-size: 32px;
      font-weight: bold;
    }
  }
  @media (min-width: 900px) {
    .slogan {
      font-size: 45px;
      font-weight: bold;
    }
  }
  @media (min-width: 1100px) {
    .slogan {
      font-size: 56px;
      font-weight: bold;
    }
  }
  .app-icon {
    width: 50px;
    height: 50px;
    margin-right: 12px;
  }
  .download-app {
    color: white;
    text-align: center;
    padding: 12px 20px;
    font-size: 12px;
    background: #0058A3;
    border: 1px solid #DFDFDF;
    border-radius: 40px;
  }
  .scroll-to-top {
    position: fixed;
    right: 30px;
    bottom: 20px;
    width: 80px;
    height: 80px;
    z-index: 100;
  }
</style>



// WEBPACK FOOTER //
// src/pages/app/AppDownload.vue